<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
        에이전트
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WSFinder</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">에이전트</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              에이전트 정보
            </div>
            <div class="mb7">
              <small class="pull-right" v-if="!add && model.created_at">등록일 : ({{model.created_at | datetime}})</small>
            </div>
          </div>
          <hr>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_groupname" v-b-tooltip.hover>회사명</label><br>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <label class="mt-2" for="ph_groupname">{{ model ? (model && model.group && model.group.groupname) : '-'}}</label>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_status" v-b-tooltip.hover>상태</label><br>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-badge class="mt-2" variant="danger" v-if="model.is_del">삭제</b-badge>
              <b-badge class="mt-2" v-else :variant="model.is_alive ? 'success' : 'secondary'">
                {{ model.is_alive ? 'On' : 'Off'}}
              </b-badge>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_service" v-b-tooltip.hover>서비스</label><br>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-badge class="mt-2" variant="success" for="ph_service">{{model && model.group && model.group.service}}</b-badge>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_info" v-b-tooltip.hover>Host@IP주소</label><br>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <label class="mt-2" for="ph_info">{{model.name || 'None'}}@{{model.ip_addr}}</label>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_version" v-b-tooltip.hover>백업모드</label><br> <!--백업 모드 Isolation-->
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-badge class="mt-2" :variant="model.setting ? (model.setting.backup_mode ? 'success' : 'secondary') : 'secondary'">
                {{model.setting ? (model.setting.backup_mode ? 'On' : 'Off') : '-'}}
              </b-badge>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_version" v-b-tooltip.hover>빌드 버전</label><br>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <label class="mt-2" for="ph_version">{{model.version}}</label>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_type" v-b-tooltip.hover>OS</label><br>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <label class="mt-2" for="ph_type">{{model.os_type}}</label>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_tag" v-b-tooltip.hover>태그</label><br>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <label class="mt-2" for="ph_tag">{{model.tag}}</label>
            </b-col>
          </b-row>
          <b-button size="sm" class="float-right mt-3" variant="primary" @click="list"> 목록 </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-modal title="Agent Remove"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      이 작업은 되돌릴 수 없습니다.
    </b-modal>
</div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>